import PortalIdParser from 'PortalIdParser';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import { stringifyQueryParams } from './queryParams';
const createExternalUrl = (path = '', query) => {
  const {
    protocol,
    hostname
  } = parseUrl(getFullUrl('app'));
  const urlOptions = {
    protocol,
    hostname,
    path,
    query: stringifyQueryParams(query || {})
  };
  return buildUrl(urlOptions);
};
export const getCheckoutInterstitialUIUrl = (query, targetFlow) => createExternalUrl(`/checkout-interstitial-ui/${PortalIdParser.get()}/${targetFlow}?${query}`);
export const getInterstitialUrl = (query = {}) => {
  return createExternalUrl(`/pricing/${PortalIdParser.get()}/interstitial`, query);
};
export const getCheckoutUrl = (purchaseOrderId, query = {}) => {
  return createExternalUrl(`/checkout/${PortalIdParser.get()}/purchases/${purchaseOrderId}`, query);
};
export const navigateTo = url => {
  if (window.hubspot.wordpress) {
    window.open(url, '_top');
  } else {
    window.location.href = url;
  }
};
export const getSupportUrl = () => {
  return createExternalUrl(`/support-inbox/${PortalIdParser.get()}?source=in-app-help`);
};